import { tradeOffersApi } from "../store/api/tradeOffersApi";
import { runMutation, runQuery } from "../store/api/runtime";

export interface TradeOfferRequestOptions {
  idempotencyKey?: string;
}

export async function createTradeOffer(payload: Record<string, unknown>, options?: TradeOfferRequestOptions): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.createTradeOffer.initiate, { payload, options });
}

export interface CreateTradeOfferMultipartPayload {
  fromUserId: string;
  toUserId: string;
  tradeId?: string | null;
  bountyId?: string | null;
  offerCardName?: string;
  offerCardGame?: string;
  offerCardId?: string;
  offerCardNameCanonical?: string;
  offerCardCondition?: string;
  offerCardValue?: number | string;
  cashAmount?: number;
  message?: string;
  offerGradingCompany?: string;
  offerGradeNumber?: string;
  file?: Blob | File | null;
  idempotencyKey?: string;
}

export async function createTradeOfferMultipart(payload: CreateTradeOfferMultipartPayload): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.createTradeOfferMultipart.initiate, payload);
}

export async function getTradeOffersForUser(userId: string): Promise<unknown[]> {
  return runQuery(tradeOffersApi.endpoints.getTradeOffersForUser.initiate, userId);
}

export async function getTradeOfferById(offerId: string): Promise<unknown> {
  return runQuery(tradeOffersApi.endpoints.getTradeOfferById.initiate, offerId);
}

export async function updateTradeOfferStatus(
  offerId: string,
  status: "accepted" | "rejected",
  counterOffer?: Record<string, unknown>,
): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.updateTradeOfferStatus.initiate, {
    offerId,
    status,
    ...(counterOffer ? { counterOffer } : {}),
  });
}

export async function cancelTradeOffer(offerId: string): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.cancelTradeOffer.initiate, { offerId });
}

export async function updateTradeOfferMeetup(
  offerId: string,
  payload: { location: string; dateTime: string; confirm?: boolean },
): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.updateTradeOfferMeetup.initiate, {
    offerId,
    payload,
  });
}

export async function confirmTradeOfferMeetup(offerId: string): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.confirmTradeOfferMeetup.initiate, { offerId });
}

export async function confirmTradeOfferExchange(offerId: string): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.confirmTradeOfferExchange.initiate, { offerId });
}

export async function submitTradeOfferReview(
  offerId: string,
  payload: { rating: number; tags: string[] },
): Promise<unknown> {
  return runMutation(tradeOffersApi.endpoints.submitTradeOfferReview.initiate, { offerId, payload });
}
